var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"label":"Deselected checkbox"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }